import React from 'react';
import { EditUserSVG, RecycleBinSVG } from '../../../../components';
import { Box, Typography, Popover } from '@mui/material';
import { useTranslation } from 'react-i18next';

export default function UsersMenuDialog ({ row, dialog, setDialog, anchorEl }) {
    const { t } = useTranslation();
    // Main Component
    return (
        <Popover open={dialog?.user?.id === row?.id && dialog?.type === 'menu'} anchorEl={anchorEl} anchorOrigin={{
            vertical: 'bottom',
            horizontal: 'left',
        }} onClose={() => setDialog(null)} PaperProps={{ style: { minWidth: '190px', borderRadius: '8px' } }}>
            <Box
                display='flex' alignItems='flex-start' justifyContent='center' flexDirection='column'>
                <button className="menu_actions--button" onClick={() => setDialog({ ...dialog, type: 'edit' })}>
                    <EditUserSVG size='24' />
                    <Typography variant='h1'>{t('users.table.menu.edit.title')}</Typography>
                </button>
                <button className="menu_actions--button" onClick={() => setDialog({ ...dialog, type: 'delete' })}
                ><RecycleBinSVG />
                    <Typography variant='h1'>{t('users.table.menu.unsubscribe.title')}</Typography>
                </button>
            </Box>
        </Popover>
    );
}
